import { useEffect, useState, useContext, useCallback } from "react";
import { getUserID, logout } from "../../Utility/service";
import { CgProfile } from "react-icons/cg";
import { Dropdown, Menu } from "antd";
import { AssistantContext } from "../../contexts/AssistantContext";
import AssistantList from "../layout/NewSidebar/AssistantList";
import CommonNavLinks from "../layout/NewSidebar/CommonNavLinks";
import UserNavLinks from "../layout/NewSidebar/UserNavLinks";
import AdminNavLinks from "../layout/NewSidebar/AdminNavLinks";
import SuperAdminNavLinks from "../layout/NewSidebar/SuperAdminNavLinks";
import { getUserAvatar, getUserData } from "../../api/userApiFunctions";
import { getAssistants } from "../../api/assistantApiFunctions";
import { FaSearch } from "react-icons/fa";
import debounce from "lodash/debounce";
import { ThemeContext } from "../../contexts/themeConfig";
import { Link, useNavigate } from "react-router-dom";
import { RiLogoutCircleLine } from "react-icons/ri";
import useAuth from "../../Hooks/useAuth";
import NavLinks from "./NavLink";
import UserAvatar from "../UserAvatar/UserAvatar";
import { ProfileContext } from "../../contexts/ProfileContext";
import SupportLinks from "../layout/NewSidebar/SupportLinks";

const NavLinksContainer = ({  chatLog, setChatLog, showTour }) => {
  const { theme } = useContext(ThemeContext);
  const userName = localStorage.userName && localStorage.userName;
  const [role, setRole] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [localShowTour, setLocalShowTour] = useState(showTour);

  // useEffect(() => {
  //   setLocalShowTour(showTour); // Update local state when prop changes
  // }, [showTour]);

  useEffect(() => {
    const handleCloseDropdown = () => setIsDropdownOpen(false);
  
    window.addEventListener("closeDropdown", handleCloseDropdown);
  
    return () => {
      window.removeEventListener("closeDropdown", handleCloseDropdown);
    };
  }, []);
 

  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const { userAvatar } = useContext(ProfileContext);

  const userId = getUserID();

  const handleFetchUserData = async () => {
    try {
      if (!userId) {
        return null;
      }
      const result = await getUserData(userId, setRole);
      if (!result) {
        console.error("Failed to fetch user data: No response received.");
        return;
      }
      const { success, data, error } = result;
      if (success) {

      } else {
        console.error("Error fetching user data:", error);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };


  useEffect(() => {
    handleFetchUserData();
  }, []);

  //------------------ API Calls -----------------------------

  const handleLogout = () => {
    localStorage.removeItem("planAlertDismissed");
    setAuth({
      role: "",
      loggedIn: false,
    });
    logout();
    navigate("/login", { replace: true });
  };

  const handleOpenChange = (open) => {
    // Prevent closing when clicking outside
    if (!open) return;
    setIsDropdownOpen(open);
  };

  //---------------------- Nav Links ---------------------
  const menu = (
    <Menu>
      {role === "superadmin" && (
        <>
          <Menu.Item key="superadmin" className="new-sidebar-color">
            <div>
              <SuperAdminNavLinks />
            </div>
          </Menu.Item>

        </>
      )}

      {role === "admin" && (
        <>
          <Menu.Item key="admin" className="new-sidebar-color">
            <AdminNavLinks />
          </Menu.Item>
        </>
      )}

      {role === "user" && (
        <>
          <Menu.Item key="user" className="new-sidebar-color">
            <UserNavLinks />
          </Menu.Item>
        </>
      )}

      <>
        <Menu.Item>
          <SupportLinks />
        </Menu.Item>
      </>

      <>
        <Link className="text-decoration-none" onClick={handleLogout}>
          <div className="navPrompt logout">
            <RiLogoutCircleLine className="logout-icon" />
            <p className="logout-text">Log Out</p>
          </div>
        </Link>
      </>


    </Menu>
  );

  return (
    <div
      className="navLinks bottom-navLinks media-navlinks"
      style={{
        padding: "0.875rem",
        width: "100%",
      }}
    >
      <Dropdown
        overlay={menu}
        placement="top"
        className="user-btn"
        trigger={["click"]}
        open={isDropdownOpen}
        onOpenChange={showTour ? handleOpenChange : (open) => setIsDropdownOpen(open)}

      >


        <div className="ant-dropdown sidebar-user-profile-btn" >
          <>
            {userAvatar ? (
              <UserAvatar
                userAvatar={userAvatar}
                width={40}
                height={30}
                shape="square"
              />
            ) : (
              <CgProfile
                size={22}
              />
            )}
            {userName && userName}
          </>
        </div>
      </Dropdown>
    </div>
  );
};

export default NavLinksContainer;
